import './external-tools';
import initializeFoundation from './foundation';
import { initializeAnalytics } from './initializeAnalytics';
import './setupDatadog';
import './setupHoneybadger';
import initializeStickySidebar from './stickySidebar';
import './whatInput';
import { onReady } from 'boot/common/domReady';

onReady(initializeAnalytics);

onReady(initializeFoundation);
onReady(initializeStickySidebar);
